/* eslint-disable consistent-return */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-restricted-globals */

'use-strict';

import angular from 'angular';

/* @ngInject */
export class TabService {
  constructor() {
    'ngInject';
  }

  /**
   * Open a new tab and display the provided HTML
   * @param {string} html
   * @param {string} pageTitle
   * @param {boolean} showPrintDialog
   */
  public openTabWithHTML(
    html: string,
    pageTitle: string,
    showPrintDialog: boolean,
  ): void {
    const wnd = window.open('about:blank', '', '_blank');
    if (!wnd) return;

    wnd.document.write(html);
    wnd.document.title = pageTitle;

    if (showPrintDialog) {
      wnd.addEventListener('load', () => {
        setTimeout(() => {
          wnd.print();
        }, 1000);
      });
    }

    wnd.document.close();
  }

  public downloadBlob(
    buffer: Buffer,
    name: string,
  ): void {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const file = new Blob([buffer], {});
    const fileURL = window.URL.createObjectURL(file);
    a.href = fileURL;
    a.download = name;
    a.click();
  }
}

export default angular.module('services.tabService', [])
  .service('tabService', TabService)
  .name;
